import React from 'react';
import DefaultReference from '../components/PanelsComponents/DefaultPanels/DefaultReference';

//= ========================================================================
const Panel_G09_SplitPaymentReference = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultReference
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    onConfigChanged={onConfigChanged}
    onGotoEdit={onGotoEdit}
    onStepPressed={onStepPressed}
    language={language}
  />
);

export default Panel_G09_SplitPaymentReference;
